<template>
  <el-form ref="form" :model="form" class="form_flex">
    <el-form-item prop="userCode">
      <el-input
        class="search-input"
        v-model="form.userCode"
        placeholder="请输入用户账号"
        @blur="onBlur"
      ></el-input>
    </el-form-item>
    <el-form-item prop="userName">
      <el-input
        class="search-input"
        v-model="form.userName"
        placeholder="请输入姓名"
        @blur="onBlur"
      ></el-input>
    </el-form-item>
    <el-form-item prop="searchValue">
      <el-select
        class="search-select"
        v-model="form.operateModule"
        clearable
        placeholder="选择操作模块"
        @blur="onBlur"
      >
        <el-option
          v-for="item in SysMenuList"
          :label="item.label"
          :value="item.value"
          :key="item.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item prop="searchValue">
      <el-select
        class="search-select"
        v-model="form.operateEvent"
        clearable
        placeholder="选择操作事件"
        @blur="onBlur"
      >
        <el-option
          v-for="item in SysOperationList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="searchValue">
      <el-select
        class="search-select"
        v-model="form.status"
        clearable
        placeholder="选择操作结果"
        @blur="onBlur"
      >
        <el-option label="失败" :value="0"></el-option>
        <el-option label="成功" :value="1"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="searchValue">
      <el-date-picker
        class="search-select"
        type="datetimerange"
        v-model="form.time"
        @blur="onBlur"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        clearable
        placeholder="选择状态"
        :default-time="['00:00:00', '23:59:59']"
      />
    </el-form-item>
    <el-form-item class="btn">
      <el-button @click="onSearch()" icon="el-icon-search" size="small"
        >查询</el-button
      >
      <el-button size="small" icon="el-icon-plus" @click="resetForm('form')"
        >清空</el-button
      >
      <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
        >刷新</el-button
      >
    </el-form-item>
    <div>
      <el-button-group>
        <PermissionsBtn
          :icon="'el-icon-download'"
          :btnType="'primary'"
          :permissionName="'_Export'"
          :downloadUrl="'/lognet/DoLog/Export'"
          :checkList="checkList"
          :form="{ ...exportForm, pageSize: 99999, pageIndex: 1 }"
        ></PermissionsBtn>
      </el-button-group>
    </div>
  </el-form>
</template>

<script>
import { encrypt } from '@/utils/encryp';
import { getSysMenuApi, getSysLoginApi, getSysOperationApi } from '@/api/log';

export default {
  name: 'UserMoneyBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      SysMenuList: [],
      LoginList: [],
      SysOperationList: [],
      form: {
        userCode: '',
        userName: '',
        operateModule: '',
        operateEvent: '',
        status: null,
        time: [],
      },
      exportForm: {
        userCode: '',
        userName: '',
        operateModule: '',
        operateEvent: '',
        startTime: null,
        endTime: null,
        status: null,
      },
    };
  },
  created() {
    getSysMenuApi().then((res) => {
      let list = [];
      for (let i in res.data) {
        list.push({ label: res.data[i], value: i });
      }
      this.SysMenuList = list;
    });
    getSysLoginApi().then((res) => {
      let list = [];
      for (let i in res.data) {
        list.push({ label: res.data[i], value: i });
      }
      // console.log('获取的登录类型', list);
      this.LoginList = list;
    });
    getSysOperationApi().then((res) => {
      let list = [];
      for (let i in res.data) {
        list.push({ label: res.data[i], value: i });
      }
      this.SysOperationList = list;
    });
  },
  methods: {
    // 获取参数
    getParams() {
      let { userName } = this.form;
      let obj = {
        ...this.form,

        userName: userName ? encrypt(userName) : '',
        status: this.form.status === '' ? null : this.form.status,
      };
      if (obj.time.length > 1) {
        obj = {
          ...obj,
          startTime: this.form.time.length > 1 ? this.form.time[0] : null,
          endTime: this.form.time.length > 1 ? this.form.time[1] : null,
        };
      }
      return obj;
    },
    // 搜索
    onSearch(pageIndex = 1) {
      let { userName } = this.form;
      this.$parent.paginObj.pageIndex = pageIndex;
      let obj = {
        ...this.form,

        userName: userName ? encrypt(userName) : '',
        status: this.form.status === '' ? null : this.form.status,
      };
      if (obj.time.length > 1) {
        obj = {
          ...obj,
          startTime: this.form.time.length > 1 ? this.form.time[0] : null,
          endTime: this.form.time.length > 1 ? this.form.time[1] : null,
        };
      }
      this.$parent.fetchData(obj);
    },

    // 失去焦点
    onBlur() {
      let { userName } = this.form;

      this.exportForm = {
        ...this.form,
        userName: userName ? encrypt(userName) : '',
        status: this.form.status === '' ? null : this.form.status,
        startTime: this.form.time.length > 1 ? this.form.time[0] : null,
        endTime: this.form.time.length > 1 ? this.form.time[1] : null,
      };
    },

    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form = {
        userCode: '',
        userName: '',
        operateModule: '',
        operateEvent: '',
        status: '',
        time: [],
      };
      this.exportForm = {
        userCode: '',
        userName: '',
        operateModule: '',
        operateEvent: '',
        startTime: '',
        endTime: '',
        status: null,
      };
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 120px;
}

.search-select1 {
  width: 100px;
}
.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
